// NATIVE
import React, { useEffect, useState } from 'react';


// INSTALLED
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import MuiDrawer from '@mui/material/Drawer';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { useSelector, useDispatch } from 'react-redux';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';






// CUSTOM
import { startLogOut } from '../../store/auth';
import { openDrawerAction } from '../../store/globals';
import { firstLetterUpperCase, storageGetCurrentUser } from '../../commons/utils';
import { getImageStore } from '../../store/files';




const drawerWidth = 250;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

export const Header = () => {
  
  const theme = useTheme();

  


  // DISPATCH 
  const dispatch = useDispatch();
  
     
  
  
  
      

  // REDUX
  const { drawer }:any  = useSelector( (state:any) => state.globals );


   // USE STATES
   const [logoUrl, setLogoUrl] = React.useState('');

  const [open, setOpen] = React.useState(false);
  

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);


  const [companyName, setCompanyName] = useState('Qi Hotels');

  useEffect(() => {
    setCompanyTitleName();
  }, []);

  useEffect(() => {
    getLogoImage();
  }, []);
  

  const setCompanyTitleName = async() => {
    const  { cliente } =  await storageGetCurrentUser();
    // console.log('tradenametradenametradename')
    // console.log(cliente)
    setCompanyName( firstLetterUpperCase(cliente.tradename) )
  }
  

  useEffect(() => {
     setOpen(drawer);
  },[drawer]);
  

  const getLogoImage = async() => { 
      
    const  { photoURL } =  await storageGetCurrentUser();
   
    const response =  await dispatch( getImageStore(photoURL, 'image-employee') );


     if ( response instanceof Blob) {
        const imageUrl = URL.createObjectURL(response);
        setLogoUrl(imageUrl);
     }

  }

  const handleDrawerOpen = async() => {
    await dispatch( openDrawerAction() );
  };


  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };


  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };


  const closeSession = async() => {
    await dispatch( startLogOut() );
    window.location.href = '/'
  };


  const settings = [
    {
       text: 'Perfil',
       action: () => {}
    },
    {
        text: 'Cuenta',
        action: () => {}
    },
    {
        text: 'Cerra session',
        action: closeSession
    },
 ];


  return (
      // <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            {companyName }
          </Typography>
          
          <Box  sx={{ flexGrow: 1, display: 'flex', justifyContent: 'end' }} >
            <Tooltip title="Opciones de usuario">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar  alt={ 'A' } src={logoUrl} />
                  <ArrowDropDownIcon  sx={{ color: 'white'}} />
                </IconButton>
            </Tooltip>
            <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
            >
                {settings.map((setting) => (
                <MenuItem key={setting.text} onClick={setting.action}>
                    <Typography textAlign="center">{setting.text}</Typography>
                </MenuItem>
                ))}
            </Menu>
            </Box>
        </Toolbar>
      </AppBar>
      
  );
}